(function () {

  function shouldShowNextBusinessDayMessage() {
    const now = new Date();

    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    const parts = formatter.formatToParts(now);

    const weekday = parts.find(part => part.type === 'weekday')?.value;
    const hour = Number(parts.find(part => part.type === 'hour')?.value);
    const minute = Number(parts.find(part => part.type === 'minute')?.value);
    const second = Number(parts.find(part => part.type === 'second')?.value);

    const isBusinessDay = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(weekday);

    const targetHour = 14;
    const targetMinute = 0;
    const targetSecond = 0;

    const currentSeconds =
      (hour * 60 * 60) +
      (minute * 60) +
      second;

    const targetSeconds =
      (targetHour * 60 * 60) +
      (targetMinute * 60) +
      targetSecond;

    const isAfterTargetTime = currentSeconds >= targetSeconds;

    return !isBusinessDay || isAfterTargetTime;
  }

  function getShippingMessage(
    baseMessage,
    sameBusinessDayMessage,
    nextBusinessDayMessage
  ) {

    if (!nextBusinessDayMessage) {
      return baseMessage;
    }

    if (shouldShowNextBusinessDayMessage()) {
      return nextBusinessDayMessage;
    }

    return sameBusinessDayMessage || baseMessage;
  }

  function updateShippingMessages(root) {
    root.querySelectorAll('[data-shipping-message-base]').forEach((element) => {

      const baseMessage =
        element.dataset.shippingMessageBase || '';

      const sameBusinessDayMessage =
        element.dataset.shippingSameDayMessage || '';

      const nextBusinessDayMessage =
        element.dataset.shippingNextDayMessage || '';

      const updatedMessage = getShippingMessage(
        baseMessage,
        sameBusinessDayMessage,
        nextBusinessDayMessage
      );

      if (element.textContent !== updatedMessage) {
        element.textContent = updatedMessage;
      }
    });
  }

  function updateShippingMessageInputs(root) {
    root.querySelectorAll('[data-shipping-message-input-base]').forEach((input) => {

      const baseMessage =
        input.dataset.shippingMessageInputBase || '';

      const sameBusinessDayMessage =
        input.dataset.shippingSameDayMessage || '';

      const nextBusinessDayMessage =
        input.dataset.shippingNextDayMessage || '';

      const updatedMessage = getShippingMessage(
        baseMessage,
        sameBusinessDayMessage,
        nextBusinessDayMessage
      );

      if (input.value !== updatedMessage) {
        input.value = updatedMessage;
      }
    });
  }

  function updateShippingMessageContent(root = document) {
    updateShippingMessages(root);
    updateShippingMessageInputs(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateShippingMessageContent();

    setInterval(() => {
      updateShippingMessageContent();
    }, 60000);
  });

  document.addEventListener(
    'on:variant:before-replace-element',
    (event) => {
      updateShippingMessageContent(event.detail.replaceWith);
    }
  );

  document.addEventListener(
    'on:variant:change',
    () => {
      updateShippingMessageContent();
    }
  );

})();